import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import jwt_decode from "jwt-decode";
import { Form, Input, Layout, Row, Col, Button, Card, Spin, Checkbox, Select, Alert, Tooltip } from 'antd';
import styled from 'styled-components';
import { requiredRule } from '../../Commons/utils';
import { SecondaryButton, DisabledButton } from '../../Commons';
import countriesJson from'../../data/countries.json'
import './userregister.scss';
import { passwordPolicy, validatePassword } from '../../utils/validationUtils';
import { 
	AiTwotoneEyeInvisible as EyeTwoTone, 
	AiOutlineEyeInvisible as EyeInvisibleOutlined,
	AiOutlineQuestionCircle as QuestionCircleOutlined
 } from 'react-icons/ai';
import { api } from '../../Http';

const UserRegister = () => {
	const { Background } = StyledComponents;
	const history = useHistory();
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);
	const [terms, setTerms] = useState(false);
	const [countries, setCountries]= useState([]);

	const [form] = Form.useForm();
	const [message, setMessage] = useState('');

	useEffect(()=>{
        let tmp = [];
        countriesJson?.map(name=>{
            tmp.push({value:name.name?.common, label:name.name?.common})
        })
        setCountries(tmp);

    },[])
	useEffect(()=>{
		const token = localStorage.getItem("token");
		const decoded = token && jwt_decode(token);
		if(decoded?.userType !== 'ADM'){
			history.replace('/login');
		}
	},[])


	const onFinish = (v) => {
		console.log({v})
		setLoading(true);
		api
		.post('/account/signup', v, { withCredentials: false })
		.then((resp) => {
			if (resp.data.code === 0) {
				history.replace("/system/users")
			} else {
				setError(resp.data.message);
				setLoading(false);
			}
		})
		.catch(() => setError('Network Error'));
		
	};

	return (
		<Layout id='register-layout'>
			<Background  justify='center' align='middle'>
					<Col xs={22} sm={16} md={12} lg={10} xl={8} xxl={7}>
						<Card className='register-card' bordered={false}>
							<Spin spinning={loading} tip='Resistering User..'>
								<div className={error ? 'error-message' : 'login-message'}>
									{error ? error : 'Register A User'}
								</div>

								<Form
									form={form}
									onFinish={(e) => onFinish(e)}
									style={{ textAlign: 'center', marginTop: '2rem' }}>
									<Form.Item name='firstName' rules={[requiredRule]}>
										<Input
											className='txt-field'
											size='large'
											placeholder='First Name'
										/>
									</Form.Item>
									<Form.Item name='lastName' rules={[requiredRule]}>
										<Input
											className='txt-field'
											size='large'
											placeholder='Last Name'
										/>
									</Form.Item>
									<Form.Item name='userName' rules={[requiredRule]} >
										<Input
											className='txt-field'
											size='large'
											placeholder='Username'
										/>
									</Form.Item>
									<Form.Item name='country'  rules={[requiredRule]}>
										<Select
											size={'large'}
											showSearch
											placeholder="Select Users Country" 
											style={{textAlign:'left'}}
											optionFilterProp="children" 
											className='txt-field'
											filterOption={(input, option) => (option?.label ?? '').includes(input)}
											filterSort={(optionA, optionB) =>
												(optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
											}
											options={countries}
										/>
										
									</Form.Item>
									<Form.Item name='email' rules={[requiredRule]} >
										<Input
											className='txt-field'
											size='large'
											placeholder='Email'
										/>
									</Form.Item>
									<Form.Item name='password' rules={[{ validator: validatePassword(form) }]}>
										{/* <Input.Password
											className='txt-field'
											size='large'
											placeholder='Password'
										/> */}
										<div style={{ display: 'flex', alignItems: 'center', position: 'relative', width:'70%', margin:'auto' }}>
												{/* Password Input */}
												<Input.Password
													className="txt-field"
													placeholder="New Password..."
													style={{ flex: 1, paddingRight: '35px', margin:'0px' }} // Ensure space for the icon
													iconRender={(visible) =>
														visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
													}
												/>

												{/* Tooltip for Password Policy - Fixed Position */}
												<Tooltip color='grey' placement="topLeft" title={passwordPolicy} trigger="click">
													<span
														style={{
															position: 'absolute',
															right: '10px',
															fontSize: '12px',
															cursor: 'pointer',
															color: 'grey',
															zIndex: 100, // Ensure it stays visible
														}}
														onClick={(e) => e.stopPropagation()} // Prevent focus loss
													>
														<QuestionCircleOutlined />
													</span>
												</Tooltip>
											</div>
									</Form.Item>
									<Form.Item
										name="confirmPassword"
										dependencies={['password']}
										hasFeedback
										rules={[
											{
												required: true,
												message: 'Please confirm your password!',
											},
											({ getFieldValue }) => ({
												validator(_, value) {
													if (!value || getFieldValue('password') === value) {
														return Promise.resolve();
													}
													return Promise.reject(new Error('The two passwords that you entered do not match!'));
												},
											}),
										]}
									>
										<Input.Password className='txt-field' placeholder='Confirm Password' size='large' />
									</Form.Item>
									
									<div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
										<Checkbox onChange={() => setTerms(!terms)}>I agree with the <a href="https://nettverk.io/msa/">Terms and Conditions</a></Checkbox>
									</div>

									<Form.Item>
										{terms ?
											<SecondaryButton

												className='nv-btn'
												htmlType='submit'
												type='primary'
												size='large'
												block>
												Register
											</SecondaryButton> :
											<DisabledButton className='nv-btn'
												disabled
												htmlType='submit'
												type='primary'
												size='large'
												block >
												Register
											</DisabledButton>}

									</Form.Item>
								</Form>
								{message && <Alert message={message} type="success" showIcon />}
							</Spin>
						</Card>
					</Col>
			</Background>
		</Layout>
	);
};

export default UserRegister;

const StyledComponents = {
	Background: styled(Row)`
	`,
	SubmitButton: styled(Button)``,
};
